import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../mock';

const FAQ = () => {
  return (
    <section id="faq" className="py-24 md:py-28 bg-[#0c0c0c] border-t border-white/10">
      <div className="max-w-3xl mx-auto px-6">
        <p className="font-display tracking-[0.35em] text-[#c9a85f] text-sm uppercase mb-5 text-center">
          FAQ
        </p>
        <h2 className="font-display font-bold text-white text-4xl md:text-5xl uppercase text-center mb-12">
          Frequently asked questions
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
              <AccordionTrigger className="font-display text-white hover:text-[#c9a85f] text-left text-lg py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 leading-relaxed text-base pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
